import {
  Component, OnInit, ChangeDetectionStrategy, Input, Inject, ChangeDetectorRef,
  EventEmitter, Output
} from '@angular/core';
import { EnumService } from '@ispm/user/services/enum.service';
import { set } from 'lodash';
import { get } from 'lodash';
import { DateHandler } from '../../../../../../shared/utils/DateHandler';

@Component({
  selector: 'gen-navican-sample',
  templateUrl: './navican-sample.component.html',
  styleUrls: ['./navican-sample.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavicanSampleComponent implements OnInit {
  @Input() sample: any;
  @Input() allowedit: boolean;
  @Input() disabledForced: boolean;
  @Input() updatedFields: string[];
  public collectionsData: any;

  @Input('collections')
  set collections(specimen) {
    this.collectionsData = specimen ? specimen : { specimenTypes: []};
  }

  @Output() callback: EventEmitter<any> = new EventEmitter();
  @Input() index: number;
  public previousValue: any;
  public returnNotesChanged;
  private selectedDatepicker: any;
  public selectedAutoComplete: any;
  tumorChanged: boolean;
  shipperChanged: boolean;
  public histopatologies: any[];
  public sites: any[];
  private invalidFieldsSet: Set<string>;

  constructor(private detector: ChangeDetectorRef, private enumService: EnumService) {
  }

  ngOnInit() {
  }

  getHistopathologies(event) {
    this.enumService.getHistopathologies(event.query).subscribe((res) => {
      this.histopatologies = res.json();
      try {
        this.detector.detectChanges();
      } catch(err) {
        console.error("navican-sample component: ChangeDetectRef was destroyed.");
      }
    });
  }

  compareBy(a: any, b: any) {
    return a && b ? a.code === b.code : a === b;
  }

  public resetValue(name) {
    set(this.sample, name, this.previousValue);
  }

  getSites(event) {
    if (event.query.length > 0) {
      this.enumService.getTopology(event.query).subscribe((res) => {
        this.sites = res.json();
        try {
          this.detector.detectChanges();
        } catch(err) {
          console.error("navican-sample component: ChangeDetectRef was destroyed.");
        }
      });
    }
    else {
      this.sites = [];
    }
  }

  markInvalid(fieldName: string, invalid: boolean): boolean {

    // check the current invalid state of the given field
    const initialized: boolean = this.invalidFieldsInit();
    const currentInvalid: boolean = (initialized && this.invalidFieldsSet.has(fieldName));

    // if no change in field's invalid state - exit, nothing to do
    if (currentInvalid === invalid) {
      return invalid;
    }

    // field should be marked as invalid - add it to the list of invalid fields
    if (invalid) {

      if (!initialized) {
        this.invalidFieldsSet = new Set();
      }

      this.invalidFieldsSet.add(fieldName);

      // field should be marked as valid - remove it from the list of invalid fields
    } else {

      if (initialized) {
        this.invalidFieldsSet.delete(fieldName);
      }

    }

    return invalid;
  }

  private invalidFieldsInit(): boolean {
    return this.invalidFieldsSet != undefined && this.invalidFieldsSet != null;
  }

  private emitChangedData(sample, field, required: boolean) {

    // invoke chane event only if all fields are valid
    if (!this.invalidFieldsInit() || this.invalidFieldsSet.size === 0) {
      this.callback.emit({ sample, field});
    }

  }

  modelChange($event, sample, field?, required?: boolean) {
    this.emitChangedData(sample, field, required);

    if ($event.target) {
      $event.target.dispatchEvent(new CustomEvent('deepBlur', { bubbles: true}));
    }
  }

  setTime(date: Date) {
    if (!(date instanceof Date)) { return; }
    date.setHours(12, 0);
    date.setTime(DateHandler.removeTimezone(date).getTime());
  }

  onDateSelect(sample, field, required: boolean) {
    this.emitChangedData(sample, field, required);

    if (this.selectedDatepicker && this.selectedDatepicker !== null) {
      this.selectedDatepicker.focus();
      this.selectedDatepicker.blur();
      this.selectedDatepicker = null;
    }
  }

  onAutoFocus($event) {
    this.selectedAutoComplete = $event.target.closest('*[deep-blur]');
  }

  onFocus($event) {
    this.selectedDatepicker = $event.target.parentElement.parentElement;
  }

  isInUpdatedFields(field: string) {
    return this.updatedFields && this.updatedFields.indexOf(field) > -1;
  }

  trackByFn(item, index) {
    return item ? item.code : index;
  }

}
